// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__3pHSg","list":"Contact_list__lLRtb","question":"Contact_question__33X-U"};